import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { apiError } from "@/lib/api";
import { Logo } from "@/components/news/Header";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { await login(email, password); navigate("/admin"); } catch (x) { setErr(apiError(x)); } finally { setBusy(false); }
  };
  return (
    <div className="grid min-h-screen place-items-center bg-[#0b0f17] px-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl bg-background p-8 shadow-2xl" data-testid="admin-login-form">
        <Logo />
        <h1 className="mt-6 flex items-center gap-2 font-serif-display text-2xl font-black"><Lock size={20} className="text-primary" />Área reservada</h1>
        <p className="mt-1 text-sm text-muted-foreground">Apenas o administrador pode publicar.</p>
        <label className="mt-6 block text-xs font-bold uppercase tracking-wider">Email</label>
        <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 h-11 w-full rounded-lg border bg-card px-3 outline-none focus:border-primary" />
        <label className="mt-4 block text-xs font-bold uppercase tracking-wider">Palavra-passe</label>
        <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 h-11 w-full rounded-lg border bg-card px-3 outline-none focus:border-primary" />
        {err && <p data-testid="admin-login-error" className="mt-3 text-sm font-semibold text-primary">{err}</p>}
        <button data-testid="admin-login-submit" disabled={busy} className="mt-6 h-11 w-full rounded-lg bg-primary font-bold text-white disabled:opacity-60">{busy ? "A entrar…" : "Entrar"}</button>
      </form>
    </div>
  );
}
